import React from "react";
import "./index.less";
import { observer } from "mobx-react-lite";
import { openUrl } from "@/utils";
import { CouponSidebarUrlMapping, CouponUrlMapping } from "./util";
import ShopType from "@/enum/ShopType";

interface CouponSidebarProps {
    shopType: ShopType;
}

const CouponSidebar: React.FC<CouponSidebarProps> = function (props) {
    const { shopType } = props;

    const imgUrl = CouponSidebarUrlMapping[shopType];

    if (!imgUrl) return null;

    function handleSideCouponClick() {
        openUrl(CouponUrlMapping[shopType]);
    }

    return (
        <div className="coupon-sidebar-container">
            <div onClick={handleSideCouponClick}>
                <img src={imgUrl} alt="" style={{ height: "75px", cursor: "pointer" }} />
            </div>
        </div>
    );
};

export default observer(CouponSidebar);
